module.exports = __webpack_public_path__ + "img/SEL90M28G.6ed9d9fd.jpg";